import React, {Component} from 'react';
import {isFreeSession, isOneToOneSessionAllowed} from "../../util/broadcast/start_broadcast";

export default class VideoTabBarButton extends Component {

    render() {
        return (
            <div className="row mt-2">
                <div className="col-md-4">
                    <a href="#"
                       className={(this.props.tabActiveIndex === 1) ? "btn btn-outline-primary active" : "btn btn-outline-primary"}
                       role="button"
                       onClick={() => {
                           this.props.setTabActiveIndex(1)
                       }}>Group requests
                        ({
                            this.props.isBroadcasterVerified
                                ?
                                (
                                    isFreeSession(this.props)
                                        ?
                                        this.props.group_request
                                        :
                                        "n/a"
                                )
                                :
                                "n/a"
                        })</a>
                </div>
                <div className="col-md-4">
                    <a href="#"
                       className={(this.props.tabActiveIndex === 2) ? "btn btn-outline-primary active" : "btn btn-outline-primary"}
                       role="button"
                       onClick={() => {
                           this.props.setTabActiveIndex(2)
                       }}>1 on 1 requests
                        ({
                            isOneToOneSessionAllowed(this.props)
                                ?
                                this.props.one_on_one_request
                                :
                                "n/a"
                        })</a>
                </div>


                {
                    this.props.isBroadcasterVerified &&
                    this.props.broadcast &&
                    this.props.broadcast.hasOwnProperty("private") &&
                    Array.isArray(this.props.broadcast.private) &&
                    <div className="col-md-4">
                        <a href="#"
                           className={(this.props.tabActiveIndex === 3) ? "btn btn-outline-primary active" : "btn btn-outline-primary"}
                           role="button"
                           onClick={() => {
                               this.props.setTabActiveIndex(3)
                           }}>Change broadcast</a>
                    </div>
                }
            </div>
        );
    }
}